import {
  LOAD_ALL_ANALYTICAL_NOTES,
  LOAD_SINGLE_ANALYTICAL_NOTE,
} from "./AnalyticalNotesList.saga";

export const loadAllAnalyticalNotes = (payload) => ({
  type: LOAD_ALL_ANALYTICAL_NOTES.LOADING,
  payload,
});

export const loadSingleAnalyticalNote = (payload) => ({
  type: LOAD_SINGLE_ANALYTICAL_NOTE.LOADING,
  payload,
});
